import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';

import { TableSkeleton } from '@eluve/blocks';
import {
  Content,
  Header,
  Heading,
  SidebarTrigger,
  Stack,
} from '@eluve/components';
import { FilterableAppointmentsTable } from '@eluve/frontend-feature-appointment';
import { useTranslation } from '@eluve/i18n';
import { useCaptureEventOnMount } from '@eluve/posthog-react';
import { useIsFeatureFlagEnabled } from '@eluve/smart-blocks';

export const AppointmentsListPage: React.FC = () => {
  const { t } = useTranslation();
  useCaptureEventOnMount('page_view_appointments_list');

  const showSuperbills = useIsFeatureFlagEnabled('BILLING_CODE_PRICES');
  const isBulkChartExportEnabled = useIsFeatureFlagEnabled('BULK_CHART_EXPORT');

  return (
    <>
      <Header>
        <SidebarTrigger />
        <div className="my-2 py-2">
          <Heading>{t('appointmentPage.appointmentsHeading')}</Heading>
        </div>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton rowCount={20} />}>
          <ErrorBoundary
            fallback={
              <Stack gap={2}>
                <p>{t('appointmentPage.appointmentsLoadFailed')}</p>
                <TableSkeleton rowCount={5} />
              </Stack>
            }
          >
            <FilterableAppointmentsTable
              includeSuperbillFiles={showSuperbills}
              enableRowSelection={isBulkChartExportEnabled}
            />
          </ErrorBoundary>
        </Suspense>
      </Content>
    </>
  );
};
